import React from 'react';

function TaskTabs({ tabs, activeTab, onChange }) {
  return (
    <div className="rounded-2xl border border-line bg-surface/80 p-2">
      <div className="flex gap-2 overflow-x-auto pb-1 sm:flex-wrap sm:overflow-visible">
        {tabs.map((tab) => {
          const isActive = tab.key === activeTab;
          const Icon = tab.icon;

          return (
            <button
              key={tab.key}
              type="button"
              data-tour={`task-tab-${tab.key}`}
              onClick={() => onChange(tab.key)}
              className={`inline-flex shrink-0 items-center gap-2 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-amber text-on-amber shadow-lg shadow-amber/20'
                  : 'text-content hover:bg-surface-2 hover:text-content'
              }`}
            >
              {Icon ? <Icon size={18} /> : null}
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default TaskTabs;
